<ul>
  @if (showVACORISTips) {
    <li>VACORIS # cannot be searched with any other field</li>
    <li>VACORIS # matches values exactly</li>
  }
  <li>First Name can only be included if Last Name is included</li>
  <li>First Name and Last Name require at least 2 characters</li>
  <li>First Name and Last Name match values that start with the entered characters</li>
  <li>SSN and SID match values exactly</li>
  <li>If SSN and SID are entered, matches on either SSN or SID are returned</li>
  <li>If Name and SSN are entered, matches on Name and SSN are returned</li>
  <li>If Name and SID are entered, matches on Name and SID are returned</li>
  <li>If Name, SSN, and SID are entered, matches on Name and SSN or Name and SID are returned</li>
  <li>A record with no SSN or SID will still be returned if it matches on Name</li>
</ul>
